// extracted by mini-css-extract-plugin
export var container = "_74-0";
export var error = "_74-9";
export var label = "_74-5";
export var light = "_74-6";
export var md = "_74-3";
export var sm = "_74-2";
export var thin = "_74-8";
export var thinBold = "_74-7";
export var vertical = "_74-4";
export var xs = "_74-1";